import { Component, OnInit, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { EcmPartsService } from '../ecm-parts.service';
import { ToastrService } from 'ngx-toastr';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'ecm-parts-modify-part-change',
  templateUrl: './ecm-parts-modify-part-change.component.html',
  styleUrls: ['./ecm-parts-modify-part-change.component.scss']
})
export class EcmPartsModifyPartChangeComponent implements OnInit {

  partChange: any;
  modifyPartChangeForm: UntypedFormGroup;

  constructor(
    private readonly dialogRef: MatDialogRef<EcmPartsModifyPartChangeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly ecmPartsService: EcmPartsService,
    private readonly toastr: ToastrService
  ) { }

  ngOnInit() {
    if (!this.data) {
      this.toastr.error('Please select a part to change.');
      return;
    }

    this.partChange = this.data;

    this.modifyPartChangeForm = new UntypedFormGroup({
      affectsDesign: new UntypedFormControl(Boolean(this.partChange.affectsDesign)),
      designDetail: new UntypedFormControl(this.partChange.designDetail),
      designAsm: new UntypedFormControl(this.partChange.designAsm),
      designItac: new UntypedFormControl(this.partChange.designItac),
      designEtac: new UntypedFormControl(this.partChange.designEtac),
      designHaf: new UntypedFormControl(this.partChange.designHaf),
      affectsGdt: new UntypedFormControl(Boolean(this.partChange.affectsGdt)),
      gdtDetail: new UntypedFormControl(this.partChange.gdtDetail),
      gdtAsm: new UntypedFormControl(this.partChange.gdtAsm),
      gdtItac: new UntypedFormControl(this.partChange.gdtItac),
      gdtEtac: new UntypedFormControl(this.partChange.gdtEtac),
      gdtHaf: new UntypedFormControl(this.partChange.gdtHaf),
    });
  }

  affectsChanged(fields: string[], val: boolean) {
    if (!val) {
      fields
        .map((field: string) => this.modifyPartChangeForm.get(field))
        .forEach((control: UntypedFormControl) => control.setValue(val));
    }
  }

  affectsDesignChanged(value: boolean) {
    const fields = ['designDetail', 'designAsm', 'designItac', 'designEtac', 'designHaf'];
    this.affectsChanged(fields, false);
  }

  affectsGdtChanged(value: boolean) {
    const fields = ['gdtDetail', 'gdtAsm', 'gdtItac', 'gdtEtac', 'gdtHaf'];
    this.affectsChanged(fields, false);
  }

  save() {
    if (!this.modifyPartChangeForm.valid) {
      this.toastr.error('Please fill in all required forms.');
      return;
    }

    // Convert boolean values to numbers for service
    const body = this.modifyPartChangeForm.value;
    for (const key in body) {
      if (typeof body[key] === 'boolean') {
        body[key] = body[key] ? 1 : 0;
      }
    }

    body.partId = this.partChange.partId;
    body.partChangeId = this.partChange.partChangeId;

    this.ecmPartsService.modifyPartChange(this.modifyPartChangeForm.value)
      .subscribe(
        this.dialogRef.close.bind(this.dialogRef),
        (err) => this.toastr.error(err, 'Failed to create part change.'),
        () => this.toastr.success('Part Change successfully updated!')
      );
  }

  close() {
    this.dialogRef.close();
  }
}
